import { DegreeTypeText } from '../../../keyword-helper/enums/DegreeTypeText';
import { KeywordHelperType } from '../../../keyword-helper/enums/KeywordHelperType';
import { KeywordHelperContent } from '../../../keyword-helper/KeywordHelperContent';

class WrongPortalMastersDefinition extends KeywordHelperContent {
	public constructor() {
		super(KeywordHelperType.WRONG_PORTAL, DegreeTypeText.MASTER, 'https://www.mastersportal.com', 'Mastersportal.com');
	}
}

export default new WrongPortalMastersDefinition();
